import {GET} from "@/services/gateway";

const getBackupsByDay = () => {
  return GET('dashboard/entraid/backups')
}

export {
  getBackupsByDay,
}
